import React from "react";

import css from "./chat_message.scss";

export const Separator = (): JSX.Element => <span className={css.messageInfoSeparator}>•</span>;
